<template>
  <div >
    <Select v-model="projectFid" class="select-width mb16" placeholder="请选择项目" @on-change="projectChange">
      <Option value="">请选择</Option>
      <Option v-for="(item,index) in projectList" :key="'project'+index" :value="item.value">{{item.text}}</Option>
    </Select>
    <table-list
      :columns="columns" :data="data" :loading="loading" :total="total"
      :current="current"
      @change-page="changePage"
    ></table-list>
    <banci-update :n="n"
                  :dataListOri="dataUpdate"
                  @update="updateScheduleConfig"
                  :projectUpdateName="projectUpdateName"
    ></banci-update>
  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import BanciUpdate from './components/BanciUpdate'
  import {getProjects} from "../../../../api/common";
  import {getScheduleConfig, updateScheduleConfig} from "../../../../api/scheduleManage";

  export default {
    name: "scheduleconfig1",
    components: {
      TableList,
      BanciUpdate
    },
    data() {
      return {
        n: 0,
        projectFid: '',
        columns: [
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title: "项目",
            key: "projectName",
            width: 250,
            align: "center"
          },
          {
            title: "班次",
            key: "scheduleConfigList",
            align: "center",
            render: (h, params) => {
              return h('div', {}, this.makeRender(params.row.scheduleConfigList, h)
              )
            }
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            render: (h, params) => {
              return h(
                'a', {
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'business/updateScheduleConfig'
                      }
                    }
                  ],
                  on: {
                    click: () => {
                      this.dataUpdate = params.row.scheduleConfigList
                      this.projectUpdateId = params.row.projectFid
                      this.projectUpdateName = params.row.projectName
                      this.n++
                      // this.showDetail(params);
                    }
                  }
                }, '修改'
              )

            }
          },

        ],
        data: [
          // {test:1}
        ],
        loading: false,
        total: 0,
        current: 1,
        page: 1,
        limit: 10,
        projectList: [],
        dataUpdate: [],
        projectUpdateId: '',
        projectUpdateName: ''

      }
    },
    methods: {
      changePage(n) {
        this.current = n
        this.page = n
        this.initPageList()
      },
      updateScheduleConfig(list, isSync) {
        let params = {
          "projectFid": this.projectUpdateId,
          "projectName": this.projectUpdateName,
          "isSyncOtherProjects": isSync == true ? '1' : '0',
          "scheduleConfigList": list
        }
        updateScheduleConfig(params).then(res => {

          this.initPageList()
        })

      },
      makeRender(list, h) {
        var ret = []
        list.forEach(ele => {
          ret.push(h('div', {
              style: {
                display: 'inline-block',
                marginLeft: '30px'
              }
            },
            [h('span', {
              style: {
                display: 'inline-block',
                width: '50px',
                textAlign:'right',
                marginRight:'10px'
              }
            }, ele.scheduleConfigName+':'),h('span',{},ele.startTime+'--'+ele.endTime)]

            // ele.scheduleConfigName+' :'+' '+ele.startTime+'--'+ele.endTime
          ))
        })
        return ret
      },
      projectChange() {
        this.page = 1
        this.current = 1
        this.initPageList()
      },
      initPageList() {
        var params = {
          projectFid: this.projectFid,
          page: this.page,
          limit: this.limit
        }
        getScheduleConfig(params).then(res => {
          this.data = res.data.rows
          this.total = res.data.total
        })
      }
    },
    created() {
      getProjects().then(res => {
       res.data && ( this.projectList = res.data)
      })
      this.initPageList()
    },
    mounted() {
    }
  }
</script>

<style scoped>
  .select-width {
    width: 200px;
  }

  .a {
    display: inline-block;
    margin-left: 30px;
  }

</style>
